export default {"src":"https://s91588.cdn.ngenix.net/affiliates-frontend/_next/static/media/credit.b093dfb2.svg","height":315,"width":375};